<div class="layout" *ngIf="!isSearch">
    <app-navbar [showMenu]="false" [showSearch]="true"></app-navbar>

    <main class="">
        <!-- Page content -->
        <div class="d-flex flex-column  container pt-3 align-items-center justify-content-around w-100 ">
            <!-- Cuando no hay módulos -->
            <div class="d-flex justify-content-center align-items-center w-100 empty-state" *ngIf="modules.length==0 && recentModules.length==0">
                <mat-card class="bg-transparent border-0 shadow-none">
                    <mat-card-content class="d-flex flex-column align-items-center text-center gap-3">

                    <img src="./../../../../assets/img/no_modul.png" alt="No hay módulos" style="max-width: 150px" />
                    <h4 class="text-gray-dark fw-medium m-0">Actualmente, no tienes módulos asignados.</h4>
                    </mat-card-content>
                </mat-card>
            </div>

            <!-- Modulos recientes -->
            <div class="row w-100 align-items-start justify-content-start m-2" style="max-width: 1200px;" *ngIf="recentModules.length>0">
                <h3 class="text-gray-dark mb-3" style="width: 100%;" *ngIf="recentModules.length>0">Usados recientemente</h3>

                <div *ngFor="let recent of treeRecentModules" class="col-12 col-md-6 col-lg-4 mb-3 d-flex justify-content-center">
                    <div class="module-card d-flex flex-column align-items-start p-3 gap-2"  (click)="goToModule(recent.module)">
                        <!-- Encabezado con icono, nombre, tres puntos -->
                        <div class="d-flex justify-content-between align-items-center w-100">
    
                            <!-- Icono + título -->
                            <div class="d-flex align-items-center gap-2" style="cursor: pointer;">
                                <mat-icon class="module-icon">{{ recent.module.imagen_url || 'folder' }}</mat-icon>
                                <strong class="module-title">{{ recent.module.descripcion_modulo | slice: 0:40 }}</strong>
                            </div>
    
                            <!-- Botón tres puntos que despliega submódulos -->
                            <button mat-icon-button
                                [matMenuTriggerFor]="recentMenu"
                                *ngIf="recent.module.opciones?.length" (click)="$event.stopPropagation()"
                                class="dots-button">
                                <mat-icon>more_vert</mat-icon>
                            </button>
    
                            <!-- Menú con árbol -->
                            <mat-menu #recentMenu="matMenu" [overlapTrigger]="false" class="p-0">
                                <mat-tree [dataSource]="recent.dataSource" [treeControl]="recent.treeControl" class="submodule-tree px-2">
                                    <!-- Nodo simple -->
                                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                                        <li>
                                            <button mat-button
                                            (click)="goToModule(recent.module, node)"
                                            class="nav-link d-flex align-items-center gap-2 w-100" style="font-size: 12px;margin-left: 14px;  white-space: nowrap;;">
                                                <mat-icon class="mr-2" style="font-size: 16px;" *ngIf="node.icono">{{ node.icono }}</mat-icon>

                                                <span style="text-align: center;">{{ node.descripcion_opcion | slice: 0:25 }}</span>
                                            </button>
                                        </li>
                                    </mat-tree-node>
    
                                    <!-- Nodo con hijos -->
                                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasRutas">
                                        <li>
                                            <div class="mat-tree-node d-flex align-items-center">
                                                <button
                                                    mat-button
                                                    matTreeNodeToggle
                                                    class="nav-link d-flex align-items-center w-100">
                                                    <mat-icon class="mr-2" *ngIf="node.icono">{{ node.icono }}</mat-icon>
                                                    <span>{{ node.descripcion_opcion | slice: 0:25 }}</span>
                                                    <mat-icon class="ml-auto">
                                                    {{ recent.treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                                    </mat-icon>
                                                </button>
                                            </div>
                                            
                                            <ul [hidden]="!recent.treeControl.isExpanded(node)" class="list-unstyled pl-3">
                                                <ng-container matTreeNodeOutlet></ng-container>
                                            </ul>
                                        </li>
                                    </mat-nested-tree-node>
                                </mat-tree>
                            </mat-menu>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Lista de todos los modulos -->
            <div *ngIf="modules.length>0" class="d-flex flex-column align-items-start m-2 w-100">
                <h3 class="text-gray-dark mb-3" style="color:#00abb0 !important; width: 100%;">Todos los módulos</h3>

                <div class="row w-100 align-items-start justify-content-center" style="max-width: 1200px;">
                    <div *ngFor="let recent of treeModules" class="col-12 col-md-6 col-lg-4 mb-3">
                        <app-card-module [module]="recent.module" [tree]="recent" (click)="goToModule(recent.module)"></app-card-module>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <app-footer></app-footer>
</div>

<div class="container search-container" *ngIf="isSearch">
    <mat-form-field appearance="fill" class="w-100">
        <mat-label style= "color: #32325d;">Buscar un módulo</mat-label>
        <input matInput type="text" maxlength="30" (keyup)="search(homeSearch.value)" #homeSearch />
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <h3 class="text-gray-dark mb-3">
        {{ homeSearch.value ? "Resultados de '" + homeSearch.value + "'" : "Todos los módulos" }}
    </h3>

    <div class="row w-100 align-items-start" *ngIf="modules.length > 0">
        <div *ngFor="let recent of treeModules" class="col-12 col-md-6 mb-3">
            <div class="module-card-search d-flex gap-3 p-2 align-items-center" (click)="goToModule(recent.module)">
                <mat-icon class="module-icon">
                {{ recent.module.imagen_url ? recent.module.imagen_url : "home" }}
                </mat-icon>
                <strong
                class="module-title m-0"
                [appTruncate]="12"
                [appTruncateText]="recent.module.descripcion_modulo || 'Sin titulo'"
                ></strong>
            </div>
        </div>
    </div>
</div>
